import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import logo from '@/assets/logo.jpeg';
import './AuthLayout.css';

interface AuthLayoutProps {
  children: React.ReactNode;
  leftContent: React.ReactNode;
}

export function AuthLayout({ children, leftContent }: AuthLayoutProps) {
  return (
    <div className="auth-layout-container flex-col md:flex-row">
      {/* ── Left panel ─────────────────────────────────────────── */}
      <div className="auth-layout-left hidden md:flex">
        {/* Bluish accent - top-left */}
        <div className="auth-accent auth-accent-tl" />
        {/* Bluish accent - top-right */}
        <div className="auth-accent auth-accent-tr" />

        <div className="auth-layout-left-content">
          <div className="auth-logo-container">
            <img src={logo} alt="FINN.AI" />
          </div>

          <h1 className="auth-brand-title">
            FINN<span>.AI</span>
          </h1>

          {leftContent}
        </div>
      </div>

      {/* ── Right panel ────────────────────────────────────────── */}
      <div className="auth-layout-right">
        {/* Back link */}
        <Link to="/" className="auth-back-link">
          <ArrowLeft size={13} /> Back to Home
        </Link>

        {/* Mobile logo */}
        <div className="auth-mobile-logo md:hidden">
          <div className="auth-mobile-logo-img">
            <img src={logo} alt="FINN.AI" />
          </div>
          <span className="auth-mobile-brand">
            FINN<span>.AI</span>
          </span>
        </div>

        {/* Form container */}
        <div className="auth-form-container">
          {children}
        </div>
      </div>
    </div>
  );
}
